import { Component, Inject, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { fromEvent, Observable } from 'rxjs';
import { MyStripeService } from 'src/app/services/apiclient/myStripe/my-stripe.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ResponseService } from 'src/app/services/manage/response/response.service';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { DeleteaddressComponent } from '../client-address/deleteaddress/deleteaddress.component';
import { TranslateService } from '@ngx-translate/core';
import {CssService} from "../../../services/css-service";
import {SalemethodService} from "../../../services/api/salemethod/salemethod.service";


declare var Stripe: any;

@Component({
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.css']
})
export class PaymentMethodsComponent implements OnInit {


  eventHeight: Observable<any> = fromEvent(window, "resize");
  innerHeight: number = window.innerHeight;



  currComp: string = "select";

  currSM: any = this.tools.getStor(SalemethodService.TAG_STORAGE);



  currPOS: any = this.tools.getStor("point_of_sale");

  clientCards: any;
  currCard$: any;
  popupMode: boolean;
  currPaymentMethod: string;


  /**
   * Stripe && card part
   */

  stripe: any;

  elements: any;

  cardNumber: any;
  cardExpiry: any;
  cardCvc: any;

  card: any;

  elementStyles: any = {
    base: {
      iconColor: '#666EE8',
      color: '#31325F',
      // lineHeight: '40px',
      fontWeight: 'bold',
      fontFamily: 'sans-serif',
      fontSize: '15px',
      textAlign: 'center',
      '::placeholder': {
        color: '#CFD7E0',
      }
    }
  };

  lang: any = this.tools.getStor("lang") ? this.tools.getStor("lang") : "fr";

  errorMessage: string | any;
  cardNeeded: boolean = false;
  rememberCard: boolean = true;

  loader: boolean = false;
  user$: any;

  defaultStripePayMethod: any;
  obserdefault: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<PaymentMethodsComponent>,
    private tools: ToolsService,
    private myStripeApi: MyStripeService,
    private responseServ: ResponseService,
    private dialog: MatDialog,
    public cssService: CssService,
    private media: MediaObserver,
    private auth: AuthService,
    public translate: TranslateService
  ) {

    // this.clientCards = data.clientCards
    this.setClientCards(data.clientCards);




    this.popupMode = data.popupMode


    // Mode recharge en ligne
    if (this.popupMode) {
      this.currSM = {
        enable_counter_payment: 0,
        enable_secure_counter_payment: 0,
        enable_online_payment: 1,
        payment_type: data.payment_type,

      }
      this.currPOS = data.currMerchant;

    }

    this.currPaymentMethod = this.currSM.payment_type;

    this.auth.getUser.subscribe(user => {
      this.user$ = user;

    });

  }

  ngOnInit() {


    this.dialogRef.disableClose = true;
    this.onWindowResize();

    this.myStripeApi.getCurrCard().subscribe(card => {

      this.currCard$ = card;
    });

   this.obserdefault= this.myStripeApi.getDefaultPaymentMethodObser().subscribe(defaultStripePayMethod => {
      this.defaultStripePayMethod = defaultStripePayMethod;

    });
  }

  ngOnDestroy(): void {
    if (this.obserdefault) {
      this.obserdefault.unsubscribe();
    }

  }

  /**
   * @description Gère le changement de composant html
   */
  changeComp(newComp: string): void {



    this.errorMessage = null;

    this.currComp = newComp;
    if (newComp === 'create' && (this.currSM.enable_online_payment > 0 || this.currSM.enable_secure_counter_payment > 0) &&
      this.currPOS.stripe_account) {


      setTimeout(() => {
        this.handleStripe();
      });


    }
  }

  /**
   * @description Selectionne une carte de paiement
   */
  selectStripeCard(selectedCard: any): void {

    //set la carte
    this.myStripeApi.setCurrCard(selectedCard);
    this.currCard$ = selectedCard
      this.currPaymentMethod = "online";

  }




  setDefaultPaymentStripeMethod(paiement_method: any, $event: any) {

    this.myStripeApi.setDefaultPaymentMethodObser(paiement_method);
    this.myStripeApi.updateCustomerPaymentsMethod(paiement_method.id).subscribe(customer_updated => {

    });
  }

  /**
   * @description Selectionne une methode de paiement et supprime la currCard
   */
  selectPaymentMethod(pm:any|string): void {

    this.currPaymentMethod = pm;
  }

  /**
   * @description Initialise stripe et gère le formulaire de cartes
   */
  handleStripe(): void {


    // if (this.cardNumber) {
    //   this.cardNumber.unmount();
    //   this.cardExpiry.unmount();
    //   this.cardCvc.unmount();
    //   this.cardNumber = null;
    //   this.cardExpiry = null;
    //   this.cardCvc = null;
    // }


    // Init stripe key
    this.myStripeApi.getStripeKey().subscribe(key => {
      if (key) {
        this.stripe = Stripe(key);

        this.elements = this.stripe.elements({
          locale: this.lang
        });

        this.cardNumber = this.elements.create('cardNumber', {
          style: this.elementStyles,
        });

        this.cardExpiry = this.elements.create('cardExpiry', {
          style: this.elementStyles,
        });

        this.cardCvc = this.elements.create('cardCvc', {
          style: this.elementStyles,
        });

        this.cardNumber.mount('#cardNumber');
        this.cardExpiry.mount('#cardExpiry');
        this.cardCvc.mount('#cardCvc');
      }
    });

  }

  /**
 * @description Crée une carte
 */
  submitForm() {

    const that = this;
    that.loader = true;
    that.errorMessage = null;

    that.stripe.createPaymentMethod(
      'card',
      that.cardNumber
    ).then(function (result: any) {


      if (result.error) {

        that.errorMessage = that.responseServ.getErrorMessage(500);
        that.loader = false;

      } else {

        if (that.rememberCard && !that.currSM.disable_authentification) {

          that.myStripeApi.createCard(result.paymentMethod.id).subscribe(data => {

            if (data.code < 0) {



              that.errorMessage = data.message;
              that.loader = false;

            } else {

              that.clientCards = data.cards;


              that.tools.openSnackBar( that.translate.instant('PaymentMethodComponent.cardCreated'), "great");
              that.changeComp('select');
              that.loader = false;
            }

          })

        } else {

          const momentaryCard = that.myStripeApi.createMomentaryCard(result.paymentMethod);
          that.clientCards.push(momentaryCard);
          that.changeComp('select');
          that.loader = false;

        }

      }

    });

  }

  /**
   * @description Set les cartes client
   */
  setClientCards(pm: any): void {

    let paymentmethod: any = [];

    if (pm)
      pm.forEach((element: any) => {
        if (element.type !== 'sepa_debit') {
          paymentmethod.push(element);
        }
      });

    this.clientCards = paymentmethod;

  }

  onWindowResize() {
    this.eventHeight.subscribe(event => {
      this.innerHeight = event.currentTarget.innerHeight;
    });
  }

  openDialDeletCard(card: any, index: number) {
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      from: "card",
      card: card,
      cards: this.clientCards,
      index: index,
      currCard: this.currCard$
    };
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "500px";
    const myDial = this.dialog.open(DeleteaddressComponent, myConf);
    myDial.afterClosed().subscribe(data => {
      if (data) {
        this.setClientCards(data);
      }
    });
  }

  openDialDeletePaymentMethod(paimentmethodstripe: any, index: number) {

    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      from: "pms",
      card: paimentmethodstripe,
      cards: this.clientCards,
      index: index,
      currCard: this.currCard$
    };
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "500px";
    const myDial = this.dialog.open(DeleteaddressComponent, myConf);
    myDial.afterClosed().subscribe(data => {
      if (data) {
        this.setClientCards(data);
      }
    });
  }

  closeDial(): void {

    /**
     * Si counter secure alors on check si une carte a été renseignée
     */
    if (this.currPaymentMethod === "secure_counter" && !this.currCard$) {
      this.cardNeeded = true;
      const objDiv: any = document.getElementById('cardneeded');
      if(objDiv){
      objDiv.scrollIntoView({ behavior: "smooth" });}
    } else {
      this.dialogRef.close({
        payment_method: this.currPaymentMethod,
        cards: this.clientCards
      });
    }

  }

}
